(function () {
  const nativeCartDrawer = document.getElementById('sidebar-cart');
  const cartTriggers = document.querySelectorAll('[data-rebuy-cart-trigger]');

  const isSmartCartEnabled = function () {
    return document.body.classList.contains('smart-cart--enabled') &&
      window.Rebuy &&
      window.Rebuy.SmartCart;
  };

  const closeNativeCartDrawer = function () {
    if (!nativeCartDrawer || !document.body.classList.contains('smart-cart--enabled')) {
      return;
    }

    if (nativeCartDrawer.getAttribute('aria-hidden') === 'false') {
      const closeButton = nativeCartDrawer.querySelector('[data-action="close-drawer"]');

      if (closeButton) {
        closeButton.click();
      }
    }
  };

  const updateCartCount = function (event) {
    const rebuyCart = event && event.detail && event.detail.cart;
    const cart = rebuyCart && rebuyCart.cart
      ? rebuyCart.cart
      : window.Rebuy && window.Rebuy.Cart && window.Rebuy.Cart.cart;

    if (!cart || typeof cart.item_count !== 'number') {
      return;
    }

    document.querySelectorAll('.Header__CartCount').forEach(function (cartCount) {
      cartCount.textContent = cart.item_count;
      cartCount.classList.toggle('is-visible', cart.item_count > 0);
    });
  };

  cartTriggers.forEach(function (trigger) {
    trigger.addEventListener('click', function (event) {
      if (!isSmartCartEnabled()) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      closeNativeCartDrawer();
      window.Rebuy.SmartCart.show(event);
    }, true);
  });

  if (nativeCartDrawer) {
    const observer = new MutationObserver(closeNativeCartDrawer);

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });
    observer.observe(nativeCartDrawer, {
      attributes: true,
      attributeFilter: ['aria-hidden']
    });
  }

  document.addEventListener('rebuy:smartcart.ready', function (event) {
    closeNativeCartDrawer();
    updateCartCount(event);
  });
  document.addEventListener('rebuy:cart.ready', updateCartCount);
  document.addEventListener('rebuy:cart.change', updateCartCount);

  closeNativeCartDrawer();
  updateCartCount();
})();
